module.exports = __webpack_public_path__ + "files/src/assets/files/new-certs/Декларация о соответствии Песок дробленный 1,2 класса.pdf";